'use client'
import { useComponentTranslation } from '@core/i18n'
import { Flex, Icon, Text } from '@core/ui-elements'
import { keyframes } from '@emotion/react'
import { MdOutlineScreenRotation } from 'react-icons/md'

const rotateAndBounce = keyframes`
  0%, 35%, 94%, 100% {
    transform: rotate(0deg);
  }
  38% {
    transform: rotate(-95deg);
  }
  41%, 47% {
    transform: rotate(-85deg);
  }
  44%, 50%, 85% {
    transform: rotate(-90deg);
  }

  88% {
    transform: rotate(5deg);
  }
  91%, 97% {
    transform: rotate(-5deg);
  }
`

export const DeviceOrientationWarning = () => {
  const t = useComponentTranslation('DeviceOrientationWarning')

  return (
    <Flex
      alignItems="center"
      background="linear-gradient(0deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.80) 100%), url(/images/background-orientation.webp) lightgray 50% / cover no-repeat"
      borderColor="blue.500"
      borderRight="8px solid"
      height="100dvh"
      justifyContent="center"
      padding="1rem"
      position="absolute"
      right="0"
      top="0"
      width="100vw"
      zIndex="1000"
    >
      <Flex
        alignItems="center"
        animation={`${rotateAndBounce} 3s infinite ease`}
        color="white"
        flexDirection="column"
        gap="1.5rem"
        justifyContent="center"
        width="100%"
      >
        <Icon
          as={MdOutlineScreenRotation}
          fontSize="10rem"
          transform="rotate(45deg)"
        />
        <Text color="white" fontSize="2rem" textAlign="center" width="95vmin">
          {t('Use your cell phone while standing')}
        </Text>
      </Flex>
    </Flex>
  )
}
